import { MATCH_STATUS } from '../constants/cash-reconciliation.constants';
/** Show dash, not a pill, when the row has no status (e.g. day off / disabled). */

export function statusIsPlain(entry: any): boolean {

  const status = (entry?.status_key ?? entry?.status ?? '')
    .toString()
    .trim()
    .toLowerCase();

  return (
    status === '' ||
    status === '--' ||
    status === '---' ||
    status === 'pending'
  );
}

export function getStatusConfig(key: string) {
  if (!key) return undefined;

  return MATCH_STATUS[key.toLowerCase().trim() as keyof typeof MATCH_STATUS];
}